import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseHttpService } from "./base.http.service";

@Injectable({
  providedIn: "root",
})
export class UploadService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  uploadFile(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);

    return this.http.post(`${this.apiUrl}/api/blogs/upload`, formData);
  }
}
